<script>
const RESULT = {
  SUCCESS: 1,
  FAIL: 2
}

export default {
  name: 'RnrFormItem',
  data() {
    return {
      result: RESULT.SUCCESS,
      message: ''
    }
  },
  methods: {
    /**
     * 表单校验结果
     */
    formValidateResult(result, message = '') {
      this.result = result ? RESULT.SUCCESS : RESULT.FAIL
      this.message = message
    }
  },
  render() {
    return (
      <div class={['validate-result-wrapper', this.result === RESULT.FAIL ? 'status-fail' : ''].join(' ')}>
        {this.$scopedSlots.default(this.formValidateResult.bind(this))}
        {this.result === RESULT.SUCCESS ? null : <div class='error-message'>{this.message}</div>}
      </div>
    )
  }
}
</script>

<style lang="scss" scoped>
.validate-result-wrapper {
  .error-message {
    color: #FF4C4F;
    font-size: 20px;
    font-weight: 400;
    height: 40px;
    padding-top: 12px;
    position: relative;

    &:after {
      position: absolute;
      box-sizing: border-box;
      content: ' ';
      pointer-events: none;
      right: 0;
      top: -1px;
      left: 0;
      border-bottom: 1PX solid #ee0a24;
      transform: scaleY(0.5);
    }
  }
  &.status-fail {
    &:after {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FormRender/form-item.vue